"use client"

import { Button } from "@rarible_int/anaconda_ui_components"
import { AnimatePresence, motion } from "motion/react"
import { CloseIcon } from "../../icons/close"
import { useScrollState } from "../headers/scroll-aware-wrapper"
import { useBannerState } from "./banner"

export function ScrollAwareBanner() {
  const { isBannerClosed, closeBanner, banner } = useBannerState()
  const { isScrolled } = useScrollState()

  if (!banner?.message?.trim()) {
    return null
  }

  return (
    <AnimatePresence>
      {!isBannerClosed && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`relative border-foreground/20 border-b-[1px] p-4 pb-[15px] text-center text-foreground/100 text-xs transition-all duration-300 ${
            isScrolled ? "bg-background/100" : "bg-transparent"
          }`}
        >
          <div className="relative">
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: temporary solution */}
            <span dangerouslySetInnerHTML={{ __html: banner.message }} />
            <Button
              variant="ghost"
              className="absolute top-0 right-0 h-4 w-4 p-0 opacity-60 hover:bg-transparent hover:opacity-100"
              onClick={closeBanner}
            >
              <CloseIcon className="h-4 w-4" />
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
